import React, { Component } from "react";
import Answer from "./Answer/Answer";
import { FormGroup } from "react-bootstrap";
import { getMisc } from "../../../../../localstorage-service";

class Question extends Component {
  appendScript() {
    // console.log(this.props.brightcoveAccountId);
    const script = document.createElement("script");
    script.src = `https://players.brightcove.net/${this.props.brightcoveAccountId}/default_default/index.min.js`;
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    if (this.props.isAssessmentSubmitted) {
      this.appendScript();
    }
    let answersHtml;
    answersHtml = (
      <FormGroup>
        {this.props.answers.map((d, i) => {
          return (
            <Answer
              questionId={this.props.questionId}
              isCorrectAnswer={d.IsCorrectAnswer}
              isUserAnswer={d.IsUserAnswer}
              tId={d.TId}
              isAssessmentSubmitted={this.props.isAssessmentSubmitted}
              answerClicked={this.props.answerClicked}
              questionTypeId={this.props.questionTypeId}
              key={d.Id}
              index={i}
              text={d.AnswerText}
            />
          );
        })}
      </FormGroup>
    );

    return (
      <div className={this.props.isAssessmentSubmitted ? "question" : ""}>
        <div>
          <h4>
            <strong>
              {getMisc("questiontitle")} {this.props.index}/
              {this.props.totalquestions}:
            </strong>{" "}
            {this.props.questionText}
          </h4>
          {this.props.questionTypeId === 1 && (
            <span className="itext">{getMisc("itextradio")}</span>
          )}
          {this.props.questionTypeId === 2 && (
            <span className="itext">{getMisc("itextcheckbox")}</span>
          )}
          <hr />
        </div>

        <div>{answersHtml}</div>
        {this.props.isAssessmentSubmitted && (
          <div className="feedback">
            <h4>{getMisc("feedback")}</h4>
            <strong>{getMisc("lessonname")}: </strong>
            {this.props.videoCategoryName}
            <br />
            <strong>{getMisc("videoname")}: </strong>
            {this.props.videoName}
            <br />
            <strong>{getMisc("referencevideo")}: </strong>
            <video
              data-video-id={this.props.brightcoveVideoId}
              data-account={this.props.brightcoveAccountId}
              data-player="default"
              data-embed="default"
              data-application-id
              className="video-js reference-video"
              controls
            />
            <script
              src={`http://players.brightcove.net/${this.props.brightcoveAccountId}/default_default/index.min.js`}
            />
            <br />
          </div>
        )}
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/Assignment/Question/Question.js